import React, { Component, createContext } from "react";
import "../styles/style.css";
import EventList from "./EventList";
import {
  fetchGalleryContent,
  fetchEventList,
  fetchAlbumPhotos,
  fetchEventData,
  fetchFoldersList,
  fetchSubFolders,
  fetchFolderEvents,
  fetchFolderEventsWithPagination,
  fetchFolderDetails,
  fetchInvitedEvents,
  deleteFolder,
  updateFolder,
  fetchEventBreadcrumbDetails,
  fetchReferenceEntityDetails,
  fetchAlbumDetails,
  updateEventAPI,
  deleteEventAPI
} from "../API/api";
import { NoEvents } from "./NoEvents";
import PhotoManagerModals from "./PhotoManagerModals";
import PhotoManagerSidebar from "./PhotoManagerSidebar";
const gssNewLoader = require("../../../assets/gss-loader.gif");

import {
  PhotoManagerProps,
  EventType,
  Album,
  PhotoManagerState,
  PhotoManagerContextType,
  PermissionFilterType,
  Folder,
  CreateFolderType,
  BasicFolderData,
  EnhancedFolder,
  ShortCutType,
  SourceEntityToMoveType
} from "./types";
import RenderContentArea from "./RenderContentArea";
import {
  decodeEntityPath,
  EntityType,
  getEncodedEntityPath,
  getEntityIdFromPath,
  getEntityInfoFromPath,
  getEntitySegment,
  getEntityTypeFromPath,
  trimEncodedEntityPathTo,
  typeMap,
  getAutoExpandIds,
  logPathExpansion
} from "./FolderFeatures/EncryptionOfFolder";

import toastr from "../../common/toastr";
import { LocalStorageHelper } from "../utils/LocalStorageHelper";
import { InstanceIdGenerator } from "../utils/InstanceIdGenerator";
import { NavigationHelpers } from "../utils/NavigationHelpers";
import {
  ModalState,
  createClearSelection,
  setFolderActions,
  setEntityToMove,
  setFolderType
} from "../utils/ModalStateHelpers";

export const PhotoManagerContext =
  createContext<PhotoManagerContextType | null>(null);

class PhotoManager extends Component<PhotoManagerProps, PhotoManagerState> {
  constructor(props: PhotoManagerProps) {
    super(props);
    this.handleResize = this.handleResize.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleEventClick = this.handleEventClick.bind(this);
    this.handlePageShow = this.handlePageShow.bind(this);

    this.state = {
      selectedEvent: null,
      selectedFolderId: null,
      selectedFolderData: null,
      selectedView: "",
      albums: {},
      eventsList: [],
      eventsView: [],
      rootFolders: [],
      rootFoldersCurrentPage: 1,
      rootFoldersNextPage: null,
      subFoldersCurrentPage: 1,
      subFoldersNextPage: null,
      foldersLoading: false,
      selectedAlbumPhotos: [],
      openedEvents: new Set<number>(),
      openedEventInstances: new Set<string>(),
      selectedAlbum: null,
      loading: true,
      isMobile: window.innerWidth < 992,
      eventCurrentPage: 1,
      photoCurrentPage: 1,
      nextPage: null,
      albumLoadingEventId: null,
      photosLoading: null,
      nextPhotoPage: null,
      photosCount: 0,
      eventListCurrentPage: 1,
      eventListNextPage: null,
      activeShareModalEventId: null,
      privacyPopupId: null,
      markUploadPopupId: null,
      eventsLoading: false,
      showNewAlbumModal: null,
      selectedMediaId: new Set(),
      confirmationLoader: false,
      showEventsFilter: false,
      selectedEventFilter: null,
      noFilteredData: false,
      isFilterEventsLoading: false,
      selectedPermissionFilters: [],
      showRedactedPhotos: null,
      showPhotosFilter: false,
      isLoadingAlbumPhotos: false,
      folderData: null,
      showCreateFolderModal: false,
      showCreateEventModal: false,
      createFolderType: "library-folder",
      openedFolders: new Set<string>(),
      folderLoadingId: null,
      isNavigatingAfterDeletion: false,
      showRenameModal: false,
      selectedFolderActions: null,
      showDeleteModal: false,
      showFolderFeatureModal: false,
      showDeleteShortcutModal: false,
      sourceShortCut: null,
      showMovePopup: false,
      sourceEntityToMove: null,
      sidebarWidth: LocalStorageHelper.getSavedSidebarWidth(),
      showRenameEventModal: false,
      showDeleteEventModal: false,
      selectedEventForAction: null,
      showHeaderCreateDropdown: false,
      isHeaderFolderCreation: false,
      isHeaderEventCreation: false,
      showManagePermissionsModal: false,
      permissionsModalContent: null
    };
  }

  setSelectedFolderActions = (folder: Folder | BasicFolderData) =>
    this.setState(setFolderActions(folder));
  setShowRenameModal = () => this.setState(ModalState.showRenameModal);
  closeRenameModal = () => this.setState(ModalState.hideRenameModal);
  setShowDeleteModal = () => this.setState(ModalState.showDeleteModal);
  closeDeleteModal = () => this.setState(ModalState.hideDeleteModal);
  setShowMovePopup = () => this.setState(ModalState.showMovePopup);
  closeMovePopup = () => this.setState(ModalState.hideMovePopup);
  setSourceEntityTypeToMove = (entity: SourceEntityToMoveType) =>
    this.setState(setEntityToMove(entity));

  handleSidebarResize = (width: number) => {
    // Enforce minimum width of 120px to ensure content is always visible
    const minWidth = 120;
    const maxWidth = 700;
    const clampedWidth = Math.max(minWidth, Math.min(maxWidth, width));

    this.setState({ sidebarWidth: clampedWidth });
    LocalStorageHelper.setSidebarWidth(clampedWidth);
  };

  setCreateFolderType = (type: CreateFolderType) =>
    this.setState(setFolderType(type));

  toggleFolderFeatureModal = (
    show: boolean,
    sourceId: number,
    sourceName: string,
    type: "LibraryFolder" | "Event",
    parentId: number | null
  ) => {
    this.setState({
      showFolderFeatureModal: show,
      sourceEntityId: sourceId,
      sourceEntityName: sourceName,
      sourceEntityType: type,
      sourceParentFolderId: parentId
    });
  };
  toggleDeleteShortcutModal = (showModal: boolean, sourceShortCut: Folder) => {
    this.setState({
      showDeleteShortcutModal: showModal,
      sourceShortCut: {
        id: sourceShortCut.id,
        parentFolderId: sourceShortCut.parentFolderId || null,
        referenceId: sourceShortCut.referenceId || null
      }
    });
  };

  openCreateEventModal = () => {
    this.setState(ModalState.showCreateEventModal);
  };

  handleCloseEventModal = () => {
    this.setState(ModalState.hideCreateEventModal);
  };

  toggleManagePermissionsModal = (
    show: boolean,
    contentType?: "LibraryFolder" | "Event",
    contentId?: number,
    contentName?: string
  ) => {
    if (show && contentType && contentId && contentName) {
      this.setState({
        showManagePermissionsModal: true,
        permissionsModalContent: { contentType, contentId, contentName }
      });
    } else {
      this.setState({
        showManagePermissionsModal: false,
        permissionsModalContent: null
      });
    }
  };

  togglePhotoSelection = (photoId: number) => {
    this.setState(prevState => {
      const updatedSelection = new Set(prevState.selectedMediaId);
      if (updatedSelection.has(photoId)) {
        updatedSelection.delete(photoId);
      } else {
        updatedSelection.add(photoId);
      }
      return { selectedMediaId: updatedSelection };
    });
  };

  clearSelection = () => {
    this.setState(createClearSelection());
  };

  setRootEventsView = () => {
    if (this.props.invitedEventsMode) {
      fetchInvitedEvents().then(({ events, meta }) => {
        this.setState({
          eventsList: events,
          eventsView: events,
          nextPage: meta.nextPage,
          eventListNextPage: meta.nextPage
        });
      });
      return;
    }

    fetchEventList(
      1,
      (val: EventType[], nextPage: number | null) => {
        this.setState({
          eventsList: [...val],
          eventsView: [...val]
        });
      },
      this.state.selectedEventFilter
    );
  };

  isFilterApplied = () => Boolean(this.state.selectedEventFilter);
  setEventsLoading = () => this.setState({ isFilterEventsLoading: true });

  fetchEventListFunction = (page: number) => {
    return fetchEventList(
      page,
      (val: EventType[], nextPage: number | null) => {
        this.setState({
          eventsList: [...val],
          eventsView: [...val],
          loading: false,
          nextPage: nextPage,
          eventListNextPage: nextPage
        });
      },
      this.state.selectedEventFilter
    );
  };

  getSelectedPhotoFilters = () => {
    return {
      permission_filters: this.state.selectedPermissionFilters,
      redacted_filter: this.state.showRedactedPhotos
    };
  };

  fetchAlbumPhotosFunction = (
    album: Album,
    page: number,
    updatePhotosCount: boolean = true
  ) => {
    const filters = this.getSelectedPhotoFilters();
    this.setState({ isLoadingAlbumPhotos: true });
    return fetchAlbumPhotos(album.id, page, filters)
      .then(photos => {
        this.setState(prevState => ({
          selectedAlbumPhotos: photos.entities,
          selectedAlbum: updatePhotosCount ? album : prevState.selectedAlbum,
          photosLoading: null,
          nextPhotoPage: photos.meta.nextPage,
          photosCount: updatePhotosCount
            ? photos.meta.photosCount
            : prevState.photosCount,
          isLoadingAlbumPhotos: false
        }));
      })
      .catch(() =>
        this.setState({ isLoadingAlbumPhotos: false, selectedAlbumPhotos: [] })
      );
  };

  handlePermissionChange = (id: number, value: null | boolean) => {
    this.setState(
      prevState => {
        const newFilters = prevState.selectedPermissionFilters.map(filter =>
          filter.attribute_id === id ? { ...filter, value } : filter
        );
        return { selectedPermissionFilters: newFilters };
      },
      () => {
        if (this.state.selectedAlbum)
          this.fetchAlbumPhotosFunction(this.state.selectedAlbum, 1);
      }
    );
  };

  handleRedactionChange = (selected: boolean) => {
    this.setState({ showRedactedPhotos: selected }, () => {
      if (this.state.selectedAlbum)
        this.fetchAlbumPhotosFunction(this.state.selectedAlbum, 1);
    });
  };

  isFilterSelected = (id: number) => {
    const active: boolean | null =
      this.state.selectedPermissionFilters.find(
        (f: PermissionFilterType) => f.attribute_id === id
      )?.value ?? null;
    return active;
  };

  resetPhotoFilters = () => {
    const defaultPermissionFilters = this.props.photoPermissionAttributes.map(
      per => ({
        attribute_id: per.attribute_id,
        value: null // Default value
      })
    );
    this.setState(
      {
        selectedPermissionFilters: defaultPermissionFilters,
        showRedactedPhotos: null,
        showPhotosFilter: false
      },
      () => {
        if (this.state.selectedAlbum)
          this.fetchAlbumPhotosFunction(this.state.selectedAlbum, 1);
      }
    );
  };

  setShowPhotoFilter = () => {
    this.setState(prevState => ({
      showPhotosFilter: !prevState.showPhotosFilter
    }));
  };

  deleteAlbumIdFromUrl = (albumId: number, updateState: boolean = true) => {
    const url = new URL(window.location.href);
    let urlChanged = false;

    // Handle legacy albumId parameter
    const urlAlbumId = url.searchParams.get("albumId");
    if (urlAlbumId && parseInt(urlAlbumId) === albumId) {
      url.searchParams.delete("albumId");
      urlChanged = true;
    }

    // Handle encoded path parameter
    const encodedPath = url.searchParams.get("p");
    if (encodedPath) {
      const decodedPath = decodeEntityPath(encodedPath);
      if (decodedPath) {
        const albumIdToRemove = `a:${albumId}`;

        // Check if the album ID exists in the path
        if (decodedPath.includes(albumIdToRemove)) {
          // Split path into segments and remove the album ID
          const pathSegments = decodedPath.split("/");
          const filteredSegments = pathSegments.filter(
            segment => segment !== albumIdToRemove
          );

          if (filteredSegments.length > 0) {
            // Re-encode the path without the album ID
            const newEncodedPath = getEncodedEntityPath(
              filteredSegments.join("/")
            );
            url.searchParams.set("p", newEncodedPath);
          } else {
            // If no segments remain, remove the path parameter entirely
            url.searchParams.delete("p");
          }
          urlChanged = true;
        }
      }
    }

    if (urlChanged) {
      window.history.pushState({}, "", url.toString());
      updateState &&
        this.setState(
          {
            selectedAlbum: null,
            selectedAlbumPhotos: []
          },
          () => this.handleURLChange()
        );
    }
  };

  updateAlbumsAfterDelete = (albumId: number, selectedAlbum: Album | null) => {
    this.setState(prevState => {
      const { albums } = prevState;
      if (!selectedAlbum) return null;
      const updatedAlbums = {
        ...albums,
        [selectedAlbum.eventId]: albums[selectedAlbum.eventId].filter(
          album => album.id !== albumId
        )
      };
      return {
        albums: updatedAlbums,
        selectedAlbum: null,
        selectedAlbumPhotos: []
      };
    });
  };
  // This is used when album is deleted from album view breadcrumbs
  onDeleteSuccess = (albumId: number) => {
    this.deleteAlbumIdFromUrl(albumId, true);
  };

  // This is used when album is deleted from albums view
  onAlbumDeleteSuccess = (albumId: number, selectedAlbum: Album) => {
    this.updateAlbumsAfterDelete(albumId, selectedAlbum);
    this.deleteAlbumIdFromUrl(albumId, false);
  };

  handlePageChange = (type: "event" | "photo", page: number) => {
    if (type === "event") {
      this.setState({ eventsLoading: true });
      this.setState({ eventCurrentPage: page }, () => {
        // Check if we're in a folder view
        if (
          this.state.selectedView === "folder" &&
          this.state.selectedFolderId
        ) {
          // Use folder events API with pagination
          fetchFolderEventsWithPagination(this.state.selectedFolderId, page)
            .then(({ events, meta }) => {
              this.setState(prevState => ({
                selectedFolderData: {
                  ...prevState.selectedFolderData!,
                  events: events
                },
                eventsLoading: false,
                eventCurrentPage: page,
                nextPage: meta.nextPage
              }));
            })
            .catch(error => {
              console.error("Failed to fetch folder events:", error);
              this.setState({ eventsLoading: false });
            });
        } else {
          // Use root events API
          fetchEventList(
            page,
            (val: EventType[], nextPage: number | null) =>
              this.setState(prevState => ({
                eventsView: [...val],
                loading: false,
                eventsLoading: false,
                eventCurrentPage: page,
                nextPage: nextPage
              })),
            this.state.selectedEventFilter
          );
        }
      });
    } else if (type === "photo") {
      const { selectedAlbum } = this.state;
      if (selectedAlbum) {
        this.setState({ photoCurrentPage: page }, () => {
          this.setState({ photosLoading: selectedAlbum.id });
          this.fetchAlbumPhotosFunction(selectedAlbum, page);
        });
      }
    }
  };

  loadMore = () => {
    if (this.state.eventListNextPage !== null) {
      this.setState({ eventsLoading: true });
      fetchEventList(
        this.state.eventListNextPage,
        (val: EventType[], nextPage: number | null) =>
          this.setState(prevState => ({
            eventsList: [...prevState.eventsList, ...val],
            loading: false,
            eventsLoading: false,
            eventListNextPage: nextPage
          })),
        this.state.selectedEventFilter
      );
    }
  };

  loadMoreRootFolders = async () => {
    if (this.state.rootFoldersNextPage === null) return;

    this.setState({ foldersLoading: true });

    try {
      const foldersResponse = await fetchFoldersList(
        this.state.rootFoldersNextPage
      );
      this.setState(prevState => ({
        rootFolders: [...prevState.rootFolders, ...foldersResponse.entities],
        rootFoldersCurrentPage:
          foldersResponse.meta.page || prevState.rootFoldersCurrentPage,
        rootFoldersNextPage: foldersResponse.meta.nextPage || null,
        foldersLoading: false
      }));
    } catch (error) {
      console.error("Failed to load more root folders:", error);
      this.setState({ foldersLoading: false });
    }
  };

  loadMoreSubFolders = async () => {
    if (this.state.subFoldersNextPage === null || !this.state.selectedFolderId)
      return;

    this.setState({ foldersLoading: true });

    try {
      const foldersResponse = await fetchSubFolders(
        this.state.selectedFolderId,
        this.state.subFoldersNextPage
      );

      this.setState(prevState => {
        if (!prevState.selectedFolderData) {
          console.error(
            "Cannot load more subfolders: selectedFolderData is null"
          );
          return { foldersLoading: false };
        }

        const updatedRootFolders = this.updateFolderInTree(
          prevState.rootFolders,
          prevState.selectedFolderId!,
          {
            children: [
              ...(prevState.selectedFolderData.folders || []),
              ...foldersResponse.entities
            ]
          }
        );

        return {
          selectedFolderData: {
            ...prevState.selectedFolderData,
            folders: [
              ...(prevState.selectedFolderData.folders || []),
              ...foldersResponse.entities
            ]
          },
          rootFolders: updatedRootFolders,
          subFoldersCurrentPage:
            foldersResponse.meta.page || prevState.subFoldersCurrentPage,
          subFoldersNextPage: foldersResponse.meta.nextPage || null,
          foldersLoading: false
        };
      });
    } catch (error) {
      console.error("Failed to load more sub-folders:", error);
      this.setState({ foldersLoading: false });
    }
  };

  // =====================================================================
  // FOLDER EXPANSION SYSTEM
  // =====================================================================
  // This system manages folder expansion state using path-based identifiers
  // to ensure that folder instances with the same ID but different locations
  // in the tree can be expanded/collapsed independently.
  //
  // Key Components:
  // - generateFolderInstanceId: Creates unique path-based identifiers
  // - handleFolderCollapse: Handles expand/collapse for specific instances
  // - autoExpandBasedOnPath: Auto-expands folders based on URL navigation
  // - loadDataForExactPath: Loads data following exact path structure
  //
  // Path Structure Examples:
  // - Root folder: "f:74"
  // - Nested folder: "f:74/f:76/f:78"
  // - Shortcut folder: "r:123" (where 123 is referenceId)
  // - Shortcut in nested path: "f:74/r:123/f:78"
  // =====================================================================

  /**
   * Generate unique identifier for folder instance based on its hierarchical path.
   * This ensures each folder instance in the tree has a unique identifier.
   *
   * Example structure:
   * - Root folder: "f:74"
   * - Child folder: "f:74/f:76"
   * - Grandchild: "f:74/f:76/f:78"
   * - Shortcut reference: "r:123" (where 123 is the referenceId)
   *
   * @param folder - The folder object to generate ID for
   * @param parentPath - The path of the parent folder (empty string for root)
   * @returns Unique folder instance identifier
   */
  generateFolderInstanceId = (
    folder: EnhancedFolder,
    parentPath: string = ""
  ): string => {
    return InstanceIdGenerator.generateFolderInstanceId(folder, parentPath);
  };

  /**
   * Get the correct path for a folder based on its position in the tree.
   * This is a fallback method when parent path is not available.
   *
   * @param folder - The folder to find the path for
   * @param rootFolders - Array of root folders to search in
   * @returns The hierarchical path string for the folder
   */
  getFolderPath = (
    folder: EnhancedFolder,
    rootFolders: EnhancedFolder[]
  ): string => {
    return InstanceIdGenerator.getFolderPath(folder, rootFolders);
  };

  /**
   * Check if a specific folder instance is expanded.
   *
   * @param folderInstanceId - The unique identifier for the folder instance
   * @returns True if the folder instance is expanded, false otherwise
   */
  isFolderInstanceExpanded = (folderInstanceId: string): boolean => {
    // Type safety check: ensure folderInstanceId is a string
    if (typeof folderInstanceId !== "string") {
      console.warn("Folder instance ID must be a string:", folderInstanceId);
      return false;
    }
    return this.state.openedFolders.has(folderInstanceId);
  };

  /**
   * Toggle expansion state for a specific folder instance.
   *
   * @param folderInstanceId - The unique identifier for the folder instance
   * @param isExpanded - True to expand, false to collapse
   */
  toggleFolderInstance = (folderInstanceId: string, isExpanded: boolean) => {
    // Type safety check: ensure folderInstanceId is a string
    if (typeof folderInstanceId !== "string") {
      console.warn("Folder instance ID must be a string:", folderInstanceId);
      return;
    }
    this.setState(prevState => {
      const newOpenedFolders = new Set(prevState.openedFolders);
      if (isExpanded) {
        newOpenedFolders.add(folderInstanceId);
      } else {
        newOpenedFolders.delete(folderInstanceId);
      }
      return { openedFolders: newOpenedFolders };
    });
  };

  /**
   * Handle folder expand/collapse operations for a specific folder instance.
   * This method ensures that only the specific folder instance is affected,
   * not all folders with the same ID across different tree locations.
   *
   * @param folder - The folder object to expand/collapse
   * @param parentPath - The hierarchical path of the parent folder
   */
  handleFolderCollapse = async (
    folder: EnhancedFolder,
    parentPath: string = ""
  ) => {
    const folderInstanceId = this.generateFolderInstanceId(folder, parentPath);
    const isCurrentlyExpanded = this.isFolderInstanceExpanded(folderInstanceId);

    if (!isCurrentlyExpanded) {
      // Expand the folder
      this.toggleFolderInstance(folderInstanceId, true);
      this.setState({ folderLoadingId: folder.id });

      try {
        const [subFoldersResponse, subEvents] = await Promise.all([
          fetchSubFolders(folder.id),
          fetchFolderEvents(folder.id)
        ]);

        this.setState(prevState => {
          const updatedRootFolders = this.updateSpecificFolderInTree(
            prevState.rootFolders,
            folder,
            { children: subFoldersResponse.entities, events: subEvents }
          );
          return { rootFolders: updatedRootFolders, folderLoadingId: null };
        });
      } catch (error) {
        console.error("Failed to load folder contents:", error);
        this.setState({ folderLoadingId: null });
      }
    } else {
      // Collapse the folder
      this.toggleFolderInstance(folderInstanceId, false);

      // Also collapse all child folder instances
      this.setState(prevState => {
        const newOpenedFolders = new Set(prevState.openedFolders);
        // Remove all folder instances that start with this folder's path
        const childPrefix = `${folderInstanceId}/`;
        newOpenedFolders.forEach(instanceId => {
          // Type safety check: ensure instanceId is a string
          if (
            typeof instanceId === "string" &&
            instanceId.startsWith(childPrefix)
          ) {
            newOpenedFolders.delete(instanceId);
          }
        });
        return { openedFolders: newOpenedFolders };
      });
    }
  };

  // =====================================================================
  // EVENT EXPANSION SYSTEM
  // =====================================================================
  // This system manages event expansion state using path-based identifiers
  // to ensure that event instances with the same ID but different locations
  // in the tree (regular events vs shortcuts) can be expanded/collapsed independently.
  //
  // Key Components:
  // - generateEventInstanceId: Creates unique path-based identifiers
  // - handleEventCollapse: Handles expand/collapse for specific instances
  // - isEventInstanceExpanded: Checks if specific instance is expanded
  // - toggleEventInstance: Toggles expansion state for specific instance
  //
  // Path Structure Examples:
  // - Regular event: "g:123"
  // - Event shortcut: "r:456" (where 456 is referenceId)
  // - Event in folder: "f:74/g:123"
  // - Event shortcut in folder: "f:74/r:456"
  // =====================================================================

  /**
   * Generate unique identifier for event instance based on its hierarchical path.
   * This ensures each event instance in the tree has a unique identifier.
   *
   * @param event - The event object to generate ID for
   * @param parentPath - The path of the parent folder (empty string for root)
   * @returns Unique event instance identifier
   */
  generateEventInstanceId = (
    event: EventType,
    parentPath: string = ""
  ): string => {
    return InstanceIdGenerator.generateEventInstanceId(event, parentPath);
  };

  /**
   * Check if a specific event instance is expanded.
   *
   * @param eventInstanceId - The unique identifier for the event instance
   * @returns True if the event instance is expanded, false otherwise
   */
  isEventInstanceExpanded = (eventInstanceId: string): boolean => {
    // Type safety check: ensure eventInstanceId is a string
    if (typeof eventInstanceId !== "string") {
      console.warn("Event instance ID must be a string:", eventInstanceId);
      return false;
    }
    return this.state.openedEventInstances.has(eventInstanceId);
  };

  /**
   * Toggle expansion state for a specific event instance.
   *
   * @param eventInstanceId - The unique identifier for the event instance
   * @param isExpanded - True to expand, false to collapse
   */
  toggleEventInstance = (eventInstanceId: string, isExpanded: boolean) => {
    // Type safety check: ensure eventInstanceId is a string
    if (typeof eventInstanceId !== "string") {
      console.warn("Event instance ID must be a string:", eventInstanceId);
      return;
    }

    this.setState(prevState => {
      const newOpenedEventInstances = new Set(prevState.openedEventInstances);
      if (isExpanded) {
        newOpenedEventInstances.add(eventInstanceId);
      } else {
        newOpenedEventInstances.delete(eventInstanceId);
      }
      return { openedEventInstances: newOpenedEventInstances };
    });
  };

  updateFolderInTree = (
    folders: EnhancedFolder[],
    folderId: number,
    updates: Partial<EnhancedFolder>
  ): EnhancedFolder[] => {
    return folders.map(folder => {
      if (folder.id === folderId) {
        return { ...folder, ...updates };
      }
      if (folder.children && folder.children.length > 0) {
        return {
          ...folder,
          children: this.updateFolderInTree(folder.children, folderId, updates)
        };
      }
      return folder;
    });
  };

  updateSpecificFolderInTree = (
    folders: EnhancedFolder[],
    targetFolder: EnhancedFolder,
    updates: Partial<EnhancedFolder>
  ): EnhancedFolder[] => {
    return folders.map(folder => {
      // Check if this is the exact folder instance we want to update
      // We'll use reference equality and additional checks to be more specific
      if (
        folder === targetFolder ||
        (folder.id === targetFolder.id &&
          folder.parentFolderId === targetFolder.parentFolderId &&
          folder.isReference === targetFolder.isReference &&
          folder.referenceId === targetFolder.referenceId)
      ) {
        return { ...folder, ...updates };
      }

      if (folder.children && folder.children.length > 0) {
        return {
          ...folder,
          children: this.updateSpecificFolderInTree(
            folder.children,
            targetFolder,
            updates
          )
        };
      }
      return folder;
    });
  };

  // Helper method to fetch event data
  private fetchEventData = async (
    event: EventType,
    finalEncodedPath: string
  ): Promise<EventType> => {
    if (event.isReference) {
      return await fetchReferenceEntityDetails(
        event.referenceId,
        finalEncodedPath
      );
    } else {
      return await fetchEventBreadcrumbDetails(
        event.id,
        null,
        finalEncodedPath
      );
    }
  };

  handleEventClick = async (event: EventType, encodedPath?: string) => {
    const { openedEvents, openedEventInstances } = this.state;
    const eventKey = event.isReference ? event.referenceId : event.id;
    const url = new URL(window.location.href);

    const pathSegment = getEntitySegment(event);
    const finalEncodedPath = encodedPath || getEncodedEntityPath(pathSegment);

    // Generate event instance ID for sidebar synchronization
    // Most events clicked from main content are at root level (no parent path)
    const eventInstanceId = this.generateEventInstanceId(event, "");

    url.searchParams.delete("folderId");
    url.searchParams.delete("albumId");
    url.searchParams.delete("eventId");
    finalEncodedPath && url.searchParams.set("p", finalEncodedPath);
    window.history.pushState({}, "", url);
    // If event is already opened
    if (openedEvents.has(eventKey)) {
      if (this.state.selectedEvent?.id !== eventKey) {
        // Select the event by fetching its breadcrumb details
        this.setState({ albumLoadingEventId: eventKey });
        try {
          const eventData = await this.fetchEventData(event, finalEncodedPath);
          this.setState({
            selectedEvent: eventData,
            selectedAlbum: null,
            albumLoadingEventId: null
          });
        } catch (err) {
          console.error("Failed to load event:", err);
          this.setState({ albumLoadingEventId: null });
        }
      } else {
        // Event is already selected, so close it
        const updatedOpenedEvents = new Set(openedEvents);
        const updatedOpenedEventInstances = new Set(openedEventInstances);

        updatedOpenedEvents.delete(eventKey);
        updatedOpenedEventInstances.delete(eventInstanceId);

        this.setState({
          openedEvents: updatedOpenedEvents,
          openedEventInstances: updatedOpenedEventInstances,
          selectedEvent: null,
          selectedAlbum: null
        });
      }
      return;
    }

    // Open and select the event
    const updatedOpenedEvents = new Set(openedEvents).add(eventKey);
    const updatedOpenedEventInstances = new Set(openedEventInstances).add(
      eventInstanceId
    );

    this.setState({
      albumLoadingEventId: eventKey,
      openedEvents: updatedOpenedEvents,
      openedEventInstances: updatedOpenedEventInstances
    });

    try {
      const [eventData, albums] = await Promise.all([
        this.fetchEventData(event, finalEncodedPath),
        fetchGalleryContent(
          event.referenceId || event.id,
          event.isReference ? "referenceId" : undefined
        )
      ]);

      this.setState(prevState => ({
        albums: { ...prevState.albums, [event.id]: albums },
        selectedEvent: eventData,
        folderData: null,
        selectedAlbum: null,
        albumLoadingEventId: null
      }));
    } catch (err) {
      console.error("Failed to load event:", err);
      this.setState({ albumLoadingEventId: null });
    }
  };

  handleEventClickInSidebar = async (
    event: EventType,
    encodedPath: string,
    open?: boolean
  ) => {
    const url = new URL(window.location.href);
    url.searchParams.delete("folderId");
    url.searchParams.delete("albumId");
    url.searchParams.delete("eventId");
    url.searchParams.set("p", encodedPath);
    window.history.pushState({}, "", url);

    this.setState({ albumLoadingEventId: event.id });

    try {
      const [eventData, albums] = await Promise.all([
        event.isReference
          ? fetchReferenceEntityDetails(event.referenceId, encodedPath)
          : fetchEventBreadcrumbDetails(event.id, null, encodedPath),
        fetchGalleryContent(
          event.referenceId || event.id,
          event.isReference ? "referenceId" : undefined
        )
      ]);
      this.setState(prevState => {
        const updatedOpenedEvents = new Set(prevState.openedEvents);
        if (open !== false) {
          updatedOpenedEvents.add(event.id);
        }
        return {
          albums: { ...prevState.albums, [eventData.id]: albums },
          selectedEvent: eventData,
          folderData: null,
          selectedView: "event",
          selectedFolderId: null,
          selectedFolderData: null,
          selectedAlbum: null,
          selectedAlbumPhotos: [],
          openedEvents: updatedOpenedEvents,
          albumLoadingEventId: null
        };
      });
    } catch (error) {
      console.error("Failed to load event data:", error);
      this.setState({
        loading: false,
        albumLoadingEventId: null
      });
    }
  };

  handleEventCollapse = (event: EventType, parentPath: string = "") => {
    const eventInstanceId = this.generateEventInstanceId(event, parentPath);
    const isCurrentlyExpanded = this.isEventInstanceExpanded(eventInstanceId);

    if (!isCurrentlyExpanded) {
      // Expand the event instance
      this.toggleEventInstance(eventInstanceId, true);
      this.setState({ albumLoadingEventId: event.id });

      try {
        fetchGalleryContent(
          event.referenceId || event.id,
          event.isReference ? "referenceId" : undefined
        ).then(albums => {
          this.setState(prevState => ({
            albums: { ...prevState.albums, [event.id]: albums },
            albumLoadingEventId: null
          }));
        });
      } catch (error) {
        console.error("Failed to load event albums:", error);
        this.setState({ albumLoadingEventId: null });
      }
    } else {
      // Collapse the event instance
      this.toggleEventInstance(eventInstanceId, false);
    }
  };

  navigateToRoot = () => {
    this.setState(NavigationHelpers.getNavigateToRootState());
    this.setRootEventsView();
  };

  navigateToAlbum = (e: any, selectedEvent: EventType) => {
    e.stopPropagation();
    this.setState(NavigationHelpers.getNavigateToAlbumState(selectedEvent));
  };

  navigateToEvents = () => {
    this.setState(NavigationHelpers.getNavigateToEventsState());
  };

  jumpToContentView = () => {
    NavigationHelpers.jumpToContentView();
  };

  handleResize = () => {
    this.setState({ isMobile: window.innerWidth < 992 });
  };

  updatePrivacy = (
    eventId: number,
    data: { id: number; publish_mode: string; password: string }
  ) => {
    const newEventsView: EventType[] = [...this.state.eventsView];
    if (newEventsView.findIndex(i => i.id === eventId) != -1) {
      newEventsView[newEventsView.findIndex(i => i.id === eventId)].password =
        data.password;
      newEventsView[
        newEventsView.findIndex(i => i.id === eventId)
      ].publishMode = data.publish_mode;
      this.setState({ eventsView: newEventsView });
    } else if (this.state.selectedEvent?.id === eventId) {
      this.setState(prevState => ({
        selectedEvent: {
          ...prevState.selectedEvent!,
          password: data.password,
          publishMode: data.publish_mode
        }
      }));
    }

    // Update nested events in selectedFolderData
    if (this.state.selectedFolderData?.events) {
      const eventIndex = this.state.selectedFolderData.events.findIndex(
        event => event.id === eventId
      );
      if (eventIndex !== -1) {
        this.setState(prevState => ({
          selectedFolderData: {
            ...prevState.selectedFolderData!,
            events: prevState.selectedFolderData!.events.map(event =>
              event.id === eventId
                ? {
                    ...event,
                    password: data.password,
                    publishMode: data.publish_mode
                  }
                : event
            )
          }
        }));
      }
    }
  };

  optimisticUpdateEventName = (eventId: number, newName: string) => {
    this.setState(prev => ({
      eventsList: prev.eventsList.map(e =>
        e.id === eventId ? { ...e, name: newName } : e
      )
    }));
  };

  optimisticUpdateFolderName = (folderId: number, newName: string) => {
    const updatedTree = this.updateFolderInTree(
      this.state.rootFolders,
      folderId,
      {
        name: newName
      }
    );
    this.setState({ rootFolders: updatedTree });
  };

  updateEventInTree = (
    folders: EnhancedFolder[],
    eventId: number,
    newName: string
  ): EnhancedFolder[] => {
    return folders.map(folder => {
      const updatedFolder = { ...folder };

      // Update events in this folder if they exist
      if (folder.events) {
        updatedFolder.events = folder.events.map(event =>
          event.id === eventId ? { ...event, name: newName } : event
        );
      }

      // Recursively update in children
      if (folder.children && folder.children.length > 0) {
        updatedFolder.children = this.updateEventInTree(
          folder.children,
          eventId,
          newName
        );
      }

      return updatedFolder;
    });
  };

  updateEventList = () => {
    this.setState({
      confirmationLoader: true
    });
    if (this.state.selectedFolderData) {
      fetchFolderEvents(this.state.selectedFolderId!).then(events => {
        this.setState({
          selectedFolderData: {
            ...this.state.selectedFolderData,
            events: events
          },
          confirmationLoader: false,
          markUploadPopupId: null
        });
      });
    } else {
      fetchEventList(
        this.state.eventCurrentPage,
        (val: any, nextPage: number) =>
          this.setState({
            eventsList: [...val],
            eventsView: [...val],
            nextPage: nextPage,
            eventListNextPage: nextPage,
            confirmationLoader: false,
            markUploadPopupId: null
          }),
        this.state.selectedEventFilter
      );
    }
  };

  showActionTooltip = (id: number | null, value: string, type: string) => {
    $(`[data-toggle="tooltip"]#${type}-icon${id ? "-" + id : ""}`)
      .attr("data-original-title", value)
      .tooltip("show");
  };

  handleAlbumClick = async (
    album: Album,
    encodedPath: string,
    event: EventType
  ) => {
    const url = new URL(window.location.href);
    url.searchParams.set("p", encodedPath);

    window.history.pushState({}, "", url);

    this.setState({ photosLoading: album.id });

    // GallerySerializer events lack bulk permission flags; only re-fetch when absent.
    const [newAlbum, photos, fullEvent] = await Promise.all([
      fetchAlbumDetails(album.id, encodedPath),
      fetchAlbumPhotos(album.id, 1),
      "canBulkTagPhotos" in event ? Promise.resolve(event) : this.fetchEventData(event, encodedPath)
    ]);

    if (!newAlbum) throw new Error("Album not found");
    if (Array.isArray(photos)) throw new Error("Photos fetch failed");

    this.setState({
      selectedAlbum: newAlbum,
      selectedAlbumPhotos: photos.entities,
      selectedView: "album",
      // fetchEventData returns [] on error; fall back to original event which has isAuthorizedForDirectDownloads.
      selectedEvent: Array.isArray(fullEvent) ? event : fullEvent,
      selectedFolderId: null,
      selectedFolderData: null,
      photosLoading: null,
      photoCurrentPage: 1,
      nextPhotoPage: photos.meta.nextPage,
      photosCount: photos.meta.photosCount
    });
    this.jumpToContentView();
  };

  onCreateAlbumSuccess = (newAlbum: Album) => {
    toastr.success("Album created successfully");

    // Directly update the albums list for this event to refresh the sidebar
    if (newAlbum.eventId) {
      this.updateAlbumsList(newAlbum);
    }
  };

  setEncodedString = (encodedString: string) => {
    this.setState({ encodedString });
  };

  refreshAlbumDetails = async (albumId: number, encodedString: string) => {
    try {
      const albumDetails = await fetchAlbumDetails(albumId, encodedString);
      if (albumDetails && this.state.selectedAlbum?.id === albumId) {
        this.setState({ selectedAlbum: albumDetails });
      }
    } catch (error) {
      console.error("Error refreshing album details:", error);
    }
  };

  /**
   * Auto-expand folders based on the current URL path.
   * This method follows the exact path structure from the URL to expand
   * only the folders that are in the navigation path.
   *
   * Example: For path "f:74/f:76/f:78", it will expand:
   * - f:74 (to show f:76)
   * - f:74/f:76 (to show f:78)
   * - f:74/f:76/f:78 (final destination)
   *
   * @param encodedPath - The base64 encoded path from the URL
   */
  autoExpandBasedOnPath = async (encodedPath: string | null) => {
    if (!encodedPath) {
      return;
    }

    logPathExpansion(encodedPath);
    const decodedPath = decodeEntityPath(encodedPath);
    if (!decodedPath) {
      return;
    }

    const { folderIds, eventIds } = getAutoExpandIds(encodedPath);

    if (folderIds.length === 0 && eventIds.length === 0) {
      return;
    }

    // Set the visual expansion state for events (events still use ID-based tracking)
    this.setState(prevState => {
      const newOpenedEvents = new Set(prevState.openedEvents);
      const newOpenedEventInstances = new Set(prevState.openedEventInstances);

      eventIds.forEach(eventId => {
        newOpenedEvents.add(eventId);
      });

      // Also set expansion state for event instances based on the path
      const segments = decodedPath.split("/");
      for (let i = 0; i < segments.length; i++) {
        const segment = segments[i];
        if (segment.startsWith("g:") || segment.startsWith("r:")) {
          // Build the path up to this event segment
          const pathToThisEvent = segments.slice(0, i + 1).join("/");
          newOpenedEventInstances.add(pathToThisEvent);
        }
      }

      return {
        openedEvents: newOpenedEvents,
        openedEventInstances: newOpenedEventInstances
      };
    });

    // Load data following the exact path structure
    await this.loadDataForExactPath(decodedPath);
  };

  // Method to load data for folders in the expansion path
  loadDataForExpandedFolders = async (
    folderIds: number[],
    eventIds: number[]
  ) => {
    // Process folders sequentially to ensure proper hierarchy loading
    for (const folderId of folderIds) {
      try {
        // Check if this folder already has children loaded
        const folderHasChildren = this.doesFolderHaveChildren(folderId);
        if (folderHasChildren) {
          continue;
        }

        // Load the folder's children
        const [subFoldersResponse, subEvents] = await Promise.all([
          fetchSubFolders(folderId),
          fetchFolderEvents(folderId)
        ]);

        // Update the folder tree with the new children
        this.setState(prevState => {
          const updatedRootFolders = this.updateFolderInTree(
            prevState.rootFolders,
            folderId,
            { children: subFoldersResponse.entities, events: subEvents }
          );
          return { rootFolders: updatedRootFolders };
        });

        // Only fetch albums for events that are in the path
        for (const event of subEvents) {
          // Only load gallery content if this event is in the path
          if (eventIds.includes(event.id) && !this.state.albums[event.id]) {
            try {
              const albums = await fetchGalleryContent(event.id);
              this.setState(prevState => ({
                albums: { ...prevState.albums, [event.id]: albums }
              }));
            } catch (error) {
              console.error(
                `Failed to load albums for event ${event.id}:`,
                error
              );
            }
          }
        }
      } catch (error) {
        console.error(`Failed to load children for folder ${folderId}:`, error);
      }
    }
  };

  // Method to load data following the exact path structure
  loadDataForExactPath = async (decodedPath: string) => {
    if (!decodedPath) return;

    const segments = decodedPath.split("/");

    // Process each segment in the path sequentially
    for (let i = 0; i < segments.length; i++) {
      const segment = segments[i];
      const [prefix, idStr] = segment.split(":");
      const id = parseInt(idStr, 10);
      const isLastSegment = i === segments.length - 1;

      if (isNaN(id)) continue;

      if (prefix === "f" || prefix === "r") {
        // Build the path up to this segment
        const pathToThisSegment = segments.slice(0, i + 1).join("/");
        const parentPath = segments.slice(0, i).join("/");

        // Find the specific folder in the tree by following the path up to this point
        const targetFolder = this.findFolderInPathAtLevel(
          segments.slice(0, i + 1)
        );

        if (!targetFolder) {
          console.warn(`Folder not found at path segment: ${segment}`);
          break;
        }

        // Mark this folder instance as expanded
        this.toggleFolderInstance(pathToThisSegment, true);

        // Check if this folder needs its children loaded
        const folderHasChildren = Boolean(
          (targetFolder.children && targetFolder.children.length > 0) ||
            (targetFolder.events && targetFolder.events.length > 0)
        );

        // Load children for any expanded folder that doesn't have them loaded yet
        if (!folderHasChildren) {
          try {
            // Load the folder's children
            const [subFoldersResponse, subEvents] = await Promise.all([
              fetchSubFolders(targetFolder.id),
              fetchFolderEvents(targetFolder.id)
            ]);

            // Update only this specific folder instance
            await new Promise<void>(resolve => {
              this.setState(prevState => {
                const updatedRootFolders = this.updateSpecificFolderInTree(
                  prevState.rootFolders,
                  targetFolder,
                  { children: subFoldersResponse.entities, events: subEvents }
                );
                return { rootFolders: updatedRootFolders };
              }, resolve);
            });
          } catch (error) {
            console.error(
              `Failed to load children for folder ${targetFolder.id}:`,
              error
            );
            break;
          }
        }
      } else if (prefix === "g") {
        // Handle event expansion if needed
        if (!this.state.albums[id]) {
          try {
            const albums = await fetchGalleryContent(id);
            this.setState(prevState => ({
              albums: { ...prevState.albums, [id]: albums }
            }));
          } catch (error) {
            console.error(`Failed to load albums for event ${id}:`, error);
          }
        }
      }
    }
  };

  // Helper function to find a folder in the tree by following a path
  findFolderInPathAtLevel = (pathSegments: string[]): EnhancedFolder | null => {
    let currentFolders = this.state.rootFolders;
    let targetFolder: EnhancedFolder | null = null;

    for (let i = 0; i < pathSegments.length; i++) {
      const segment = pathSegments[i];
      const [prefix, idStr] = segment.split(":");
      const id = parseInt(idStr, 10);

      if (isNaN(id)) return null;

      // Find the folder at this level
      targetFolder =
        currentFolders?.find(folder => {
          if (prefix === "f") {
            return folder.id === id && !folder.isReference;
          } else if (prefix === "r") {
            return folder.referenceId === id && folder.isReference;
          }
          return false;
        }) || null;

      if (!targetFolder) {
        return null;
      }

      // If this is not the last segment, move to the next level
      if (i < pathSegments.length - 1) {
        currentFolders = targetFolder.children || [];
      }
    }

    return targetFolder;
  };

  // Helper method to check if a folder already has children loaded
  doesFolderHaveChildren = (folderId: number): boolean => {
    const findFolderInTree = (
      folders: EnhancedFolder[],
      targetId: number
    ): EnhancedFolder | null => {
      for (const folder of folders) {
        if (folder.id === targetId) {
          return folder;
        }
        if (folder.children && folder.children.length > 0) {
          const found = findFolderInTree(folder.children, targetId);
          if (found) return found;
        }
      }
      return null;
    };

    const folder = findFolderInTree(this.state.rootFolders, folderId);
    if (!folder) {
      return false;
    }

    // Check if folder has children or events loaded
    const hasChildren = Boolean(
      (folder.children && folder.children.length > 0) ||
        (folder.events && folder.events.length > 0)
    );

    return hasChildren;
  };

  handleURLChange = async () => {
    const url = new URL(window.location.href);
    const encodedPath = url.searchParams.get("p");

    if (!encodedPath) {
      this.setState({
        selectedEvent: null,
        selectedAlbum: null,
        selectedAlbumPhotos: [],
        selectedFolderId: null,
        selectedFolderData: null,
        selectedView: ""
      });
      return;
    }

    const decodedPath = decodeEntityPath(encodedPath);
    const { type, id } = getEntityInfoFromPath(decodedPath);

    if (!type || id == null) {
      console.warn("Invalid entity type or id in path:", decodedPath);
      this.setState({ loading: false });
      return;
    }

    const pathSegments = decodedPath.split("/");
    const parentSegment = pathSegments[pathSegments.length - 2]; // e.g. g:252 or r:62
    const [parentPrefix, parentIdString] = parentSegment?.split(":") || [];
    const parentId = parseInt(parentIdString, 10);
    const isReference = parentPrefix === "r";

    this.setState({ loading: true, encodedString: encodedPath });

    // Auto-expand folders and events based on the current path
    await this.autoExpandBasedOnPath(encodedPath);

    // Reset the navigation flag if it was set
    if (this.state.isNavigatingAfterDeletion) {
      this.setState({ isNavigatingAfterDeletion: false });
    }

    try {
      //Folder / Folder Shortcut
      if (type === "folder") {
        const [data, folderMeta] = await Promise.all([
          this.fetchFolderDetails(id),
          fetchFolderDetails(id)
        ]);
        const isEmpty = data.folders.length === 0 && data.events.length === 0;

        this.setState({
          selectedFolderId: id,
          selectedFolderData: {
            ...(folderMeta || {}),
            folders: data.folders,
            events: data.events
          },
          folderData: folderMeta,
          selectedView: isEmpty ? "empty-folder" : "folder",
          selectedEvent: null,
          selectedAlbum: null,
          selectedAlbumPhotos: [],
          loading: false,
          subFoldersCurrentPage: 1,
          subFoldersNextPage: data.foldersNextPage,
          nextPage: data.meta.nextPage,
          eventCurrentPage: 1
        });
        return;
      }

      //Shortcut Folder or Shortcut Event (type === reference)
      if (type === "reference") {
        const data = await fetchReferenceEntityDetails(id, encodedPath);

        if (data.type === "LibraryFolder") {
          const [foldersResponse, eventsResponse, folderMeta] =
            await Promise.all([
              fetchSubFolders(data.id, 1),
              fetchFolderEventsWithPagination(data.id, 1),
              fetchFolderDetails(data.id)
            ]);
          const folders = foldersResponse.entities;
          const events = eventsResponse.events;
          const isEmpty =
            (!Array.isArray(folders) || folders.length === 0) &&
            (!Array.isArray(events) || events.length === 0);

          this.setState({
            selectedFolderId: data.id,
            selectedFolderData: {
              ...(folderMeta || {}),
              folders: folders || [],
              events: events || []
            },
            folderData: folderMeta,
            selectedView: isEmpty ? "empty-folder" : "folder",
            selectedEvent: null,
            selectedAlbum: null,
            selectedAlbumPhotos: [],
            loading: false,
            subFoldersCurrentPage: 1,
            subFoldersNextPage: foldersResponse.meta.nextPage,
            nextPage: eventsResponse.meta.nextPage,
            eventCurrentPage: 1
          });
          return;
        }
        if (data.type === "Gallery") {
          const albums = await fetchGalleryContent(id, "referenceId");
          this.setState({
            selectedEvent: data,
            albums: { ...this.state.albums, [data.id]: albums },
            selectedView: "event",
            selectedFolderId: null,
            selectedFolderData: null,
            selectedAlbum: null,
            selectedAlbumPhotos: [],
            loading: false
          });
          return;
        }
      }

      //Event (non-shortcut)
      if (type === "gallery") {
        const event = await fetchEventBreadcrumbDetails(id, null, encodedPath);
        if (Array.isArray(event)) return this.redirectToLibraryHome();
        const albums = await fetchGalleryContent(id);

        this.setState({
          selectedEvent: event,
          albums: { ...this.state.albums, [event.id]: albums },
          selectedView: "event",
          selectedFolderId: null,
          selectedFolderData: null,
          selectedAlbum: null,
          selectedAlbumPhotos: [],
          loading: false
        });
        return;
      }

      //Album
      if (type === "album") {
        const isParentShortcut = parentPrefix === "r";

        const [event, album, photos] = await Promise.all([
          fetchEventBreadcrumbDetails(
            parentId,
            isParentShortcut ? parentId : null,
            encodedPath
          ),
          fetchAlbumDetails(id, encodedPath),
          fetchAlbumPhotos(id, 1)
        ]);

        // fetch helpers return [] on network error; guard before accessing properties.
        if (Array.isArray(event)) return this.redirectToLibraryHome();
        if (!album) throw new Error("Album not found");
        if (Array.isArray(photos)) throw new Error("Photos fetch failed");

        this.setState({
          selectedAlbum: album,
          selectedAlbumPhotos: photos.entities,
          selectedView: "album",
          selectedEvent: event,
          selectedFolderId: null,
          selectedFolderData: null,
          loading: false,
          photosLoading: null,
          nextPhotoPage: photos.meta.nextPage,
          photosCount: photos.meta.photosCount
        });
        return;
      }

      console.warn("Unhandled entity type in URL:", type);
      this.setState({ loading: false });
    } catch (error) {
      console.error("Error in handleURLChange:", error);
      this.setState({ loading: false });
    }
  };

  redirectToLibraryHome = () => {
    window.history.replaceState(null, "", "/library");
    this.setState({
      loading: false,
      selectedEvent: null,
      selectedAlbum: null,
      selectedAlbumPhotos: [],
      selectedFolderId: null,
      selectedFolderData: null,
      selectedView: ""
    });
  };

  fetchFolderDetails = async (folderId: number, type?: string) => {
    const [foldersResponse, eventsResponse] = await Promise.all([
      type === "LibraryFolderReference"
        ? fetchSubFolders(folderId, 1, "LibraryFolderReference")
        : fetchSubFolders(folderId, 1),
      type === "LibraryFolderReference"
        ? fetchFolderEventsWithPagination(folderId, 1, "LibraryFolderReference")
        : fetchFolderEventsWithPagination(folderId, 1)
    ]);

    return {
      folders: foldersResponse.entities,
      events: eventsResponse.events,
      foldersNextPage: foldersResponse.meta.nextPage,
      meta: eventsResponse.meta
    };
  };

  async removeFolderFromEncodedPath(folderId: number) {
    const url = new URL(window.location.href);
    const encoded = url.searchParams.get("p");
    if (!encoded) return;

    const decoded = decodeEntityPath(encoded);
    const updatedPath = decoded
      .split("/")
      .filter(seg => !seg.endsWith(`:${folderId}`))
      .join("/");
    const newEncoded = getEncodedEntityPath(updatedPath);

    if (newEncoded) {
      url.searchParams.set("p", newEncoded);
    } else {
      url.searchParams.delete("p");
    }
    window.history.pushState({}, "", url.toString());

    await new Promise(resolve => setTimeout(resolve, 0));
    this.handleURLChange();
  }

  componentDidMount() {
    const invitedEventsMode = this.props.invitedEventsMode;

    window.addEventListener("resize", this.handleResize);
    window.addEventListener("popstate", this.handleURLChange);
    window.addEventListener("pageshow", this.handlePageShow);
    document.addEventListener("click", this.handleClickOutside);

    const eventsPromise = invitedEventsMode
      ? fetchInvitedEvents().then(({ events, meta }) => {
          this.setState({
            eventsList: events,
            eventsView: events,
            loading: false,
            nextPage: meta.nextPage,
            eventListNextPage: meta.nextPage
          });
        })
      : this.fetchEventListFunction(this.state.eventCurrentPage);

    const promises: Promise<any>[] = [eventsPromise];

    if (!invitedEventsMode) {
      promises.push(fetchFoldersList(1));
    }

    Promise.all(promises).then(async ([_, foldersResponse]) => {
      if (!invitedEventsMode && foldersResponse) {
        const rootFolders = foldersResponse.entities;
        const meta = foldersResponse.meta;
        this.setState(
          {
            rootFolders,
            rootFoldersCurrentPage: meta.page || 1,
            rootFoldersNextPage: meta.nextPage || null
          },
          async () => {
            await this.handleURLChange();
            this.setState({ loading: false }, () =>
              buildFolderTree(rootFolders, this.state.eventsList)
            );
          }
        );
      } else {
        await this.handleURLChange();
        this.setState({ loading: false });
      }
    });

    const defaultPermissionFilters = this.props.photoPermissionAttributes.map(
      per => ({
        attribute_id: per.attribute_id,
        value: null // Default value
      })
    );
    this.setState({ selectedPermissionFilters: defaultPermissionFilters });

    const buildFolderTree = (
      folders: EnhancedFolder[],
      events: EventType[]
    ): EnhancedFolder[] => {
      const folderMap = new Map<number, EnhancedFolder>();
      folders.forEach(folder =>
        folderMap.set(folder.id, { ...folder, children: [], events: [] })
      );

      const root: EnhancedFolder[] = [];

      folders.forEach(folder => {
        if (folder.parentFolderId) {
          const parent = folderMap.get(folder.parentFolderId);
          if (parent) parent.children!.push(folderMap.get(folder.id)!);
        } else {
          root.push(folderMap.get(folder.id)!);
        }
      });

      return root;
    };
  }

  handlePageShow = async (event: { persisted: any }) => {
    if (event.persisted && !this.state.eventsList.length) {
      this.fetchEventListFunction(this.state.eventCurrentPage).then(() => {
        this.handleURLChange();
      });
    }
  };

  applyEventsFilter = (filter: string | null) => {
    this.setState(
      {
        selectedEventFilter: filter
      },
      () =>
        fetchEventList(
          1,
          (val: EventType[], nextPage: number | null) => {
            this.setState({
              noFilteredData: val.length <= 0,
              showEventsFilter: false,
              isFilterEventsLoading: false,
              eventsList: [...val],
              eventsView: [...val],
              loading: false,
              nextPage: nextPage,
              eventListNextPage: nextPage,
              selectedEvent: null,
              eventCurrentPage: 1
            });
            window.history.pushState({}, "", "/library");
          },
          filter
        )
    );
  };
  showEventsFilterPanel = () =>
    this.setState({
      showEventsFilter: !this.state.showEventsFilter
    });
  closeFilterEventsPanel = () =>
    this.setState({
      showEventsFilter: false
    });

  clearFilter = () => {
    this.setState({ isFilterEventsLoading: true }, () =>
      this.applyEventsFilter(null)
    );
  };
  componentDidUpdate(prevProps: any, prevState: any) {
    if (prevState.selectedFolderId !== this.state.selectedFolderId) {
      $(".tooltip").remove();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("popstate", this.handleURLChange);
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("pageshow", this.handlePageShow);
    document.removeEventListener("click", this.handleClickOutside);
  }

  findEventById = (eventId: number, list: EventType[]) =>
    list.find((event: EventType) => event.id === eventId);

  getAlbumsData = (
    eventId: number,
    albums: Record<number, Album[]>,
    eventsList: EventType[],
    selectedEvent: EventType | null
  ): Album[] =>
    albums?.[this.findEventById(eventId, eventsList)?.id ?? 0] ||
    (selectedEvent ? albums[selectedEvent.id] : []) ||
    [];

  setMarkUploadCompletePopup = (val: number | null) => {
    this.setState({ markUploadPopupId: val });
  };

  setActiveShareModalEventId = (id: number | null) => {
    this.setState({ activeShareModalEventId: id });
  };

  setPrivacyPopupId = (id: number | null) => {
    this.setState({ privacyPopupId: id });
  };

  setShowNewAlbumModal = (id: number | null) => {
    this.setState({ showNewAlbumModal: id });
  };

  setShowCreateFolderModal = (show: boolean) => {
    this.setState({ showCreateFolderModal: show });
  };

  setShowCreateEventModal = (show: boolean) => {
    this.setState({ showCreateEventModal: show });
  };

  setShowFolderFeatureModal = (show: boolean) => {
    this.setState({ showFolderFeatureModal: show });
  };

  setShowDeleteShortcutModal = (show: boolean) => {
    this.setState({ showDeleteShortcutModal: show });
  };

  onCloseFolderFeatureModal = () => {
    this.setState({ showFolderFeatureModal: false });
  };

  onCloseDeleteShortcutModal = () => {
    this.setState({ showDeleteShortcutModal: false });
  };

  updateAlbumsList = (val: Album) => {
    fetchGalleryContent(val.eventId).then(albums => {
      this.setState(prevState => ({
        albums: { ...prevState.albums, [val.eventId]: albums },
        albumLoadingEventId: null
      }));
    });
  };

  onEditSuccessUpdateAlbum = (updatedAlbum: Album) => {
    this.setState(prevState => ({
      // Update the album in the albums list
      albums: {
        ...prevState.albums,
        [updatedAlbum.eventId]: prevState.albums[updatedAlbum.eventId]?.map(
          album =>
            album.id === updatedAlbum.id ? { ...album, ...updatedAlbum } : album
        ) || [updatedAlbum]
      },
      // Update selectedAlbum if it's the same album
      selectedAlbum:
        prevState.selectedAlbum?.id === updatedAlbum.id
          ? { ...prevState.selectedAlbum, ...updatedAlbum }
          : prevState.selectedAlbum
    }));
  };

  isFilterAppliedButResultEmpty = () =>
    this.isFilterApplied() &&
    this.state.eventsList.length == 0 &&
    !this.state.isMobile;

  noFolderOrEventsAvailable = () =>
    this.state.eventsList.length == 0 &&
    this.state.rootFolders.length === 0 &&
    this.state.showEventsFilter;

  setSelectedView = (view: "folder" | "album" | null) => {
    if (view) {
      this.setState({ selectedView: view });
    } else {
      this.setState({ selectedView: "" });
    }
  };

  setFolderData = (folderData: { id: number; name: string } | null) => {
    this.setState({ folderData, selectedFolderId: folderData?.id || null });
  };
  setDeletedViewState = () => {
    this.setState({
      selectedEvent: null,
      selectedAlbum: null,
      selectedAlbumPhotos: [],
      selectedView: ""
    });
  };

  handleFolderClick = async (folder: EnhancedFolder, encodedPath: string) => {
    const url = new URL(window.location.href);
    url.searchParams.set("p", encodedPath);
    window.history.pushState({}, "", url);

    this.setState({ folderLoadingId: folder.id });

    try {
      let folders = [];
      let events = [];
      let foldersNextPage = null;
      let eventsNextPage = null;

      if (folder.isReference && folder.referenceId) {
        const data = await fetchReferenceEntityDetails(
          folder.referenceId,
          encodedPath
        );
        const foldersResponse = await fetchSubFolders(data.id, 1);
        folders = foldersResponse.entities;
        foldersNextPage = foldersResponse.meta.nextPage;
        const eventsResponse = await fetchFolderEventsWithPagination(
          data.id,
          1
        );
        events = eventsResponse.events;
        eventsNextPage = eventsResponse.meta.nextPage;
      } else {
        const data: any = await this.fetchFolderDetails(folder.id);
        folders = data.folders;
        events = data.events;
        foldersNextPage = data.foldersNextPage;
        eventsNextPage = data.meta.nextPage;
      }

      const isEmpty = folders.length === 0 && events.length === 0;

      this.setState({
        selectedFolderId: folder.id,
        selectedFolderData: {
          ...folder,
          folders,
          events
        },
        selectedView: isEmpty ? "empty-folder" : "folder",
        folderData: folder,
        selectedEvent: null,
        selectedAlbum: null,
        selectedAlbumPhotos: [],
        folderLoadingId: null,
        subFoldersCurrentPage: 1,
        subFoldersNextPage: foldersNextPage,
        nextPage: eventsNextPage,
        eventCurrentPage: 1
      });
    } catch (error) {
      console.error("Failed to load folder data:", error);
    }
  };

  handleFolderClickInSidebar = async (
    folder: EnhancedFolder,
    encodedPath: string
  ) => {
    // Differnetiate between the same folder and its shortcuts (which have different encoded paths)
    if (
      this.state.selectedFolderId === folder.id &&
      this.state.encodedString === encodedPath
    ) {
      // Get the parent path from the encoded path to generate the correct folder instance ID
      const decodedPath = decodeEntityPath(encodedPath);
      const pathSegments = decodedPath.split("/");
      const parentPath = pathSegments.slice(0, -1).join("/");
      const folderInstanceId = this.generateFolderInstanceId(
        folder,
        parentPath
      );

      this.setState(prevState => {
        const updatedOpenedFolders = new Set(prevState.openedFolders);
        updatedOpenedFolders.delete(folderInstanceId);
        return { openedFolders: updatedOpenedFolders };
      });
      return;
    }

    const url = new URL(window.location.href);
    url.searchParams.delete("eventId");
    url.searchParams.delete("albumId");
    url.searchParams.set("p", encodedPath);
    window.history.pushState({}, "", url);

    this.setState({ folderLoadingId: folder.id });

    try {
      let folders = [];
      let events = [];
      let nextPage = null;

      let foldersNextPage = null;

      if (folder.isReference && folder.referenceId) {
        const data = await fetchReferenceEntityDetails(
          folder.referenceId,
          encodedPath
        );
        const foldersResponse = await fetchSubFolders(data.id, 1);
        folders = foldersResponse.entities;
        foldersNextPage = foldersResponse.meta.nextPage;
        const eventsResponse = await fetchFolderEventsWithPagination(
          data.id,
          1
        );
        events = eventsResponse.events;
        nextPage = eventsResponse.meta.nextPage;
      } else {
        const data: any = await this.fetchFolderDetails(
          folder.referenceId || folder.id
        );
        folders = data.folders;
        events = data.events;
        foldersNextPage = data.foldersNextPage;
        nextPage = data.meta.nextPage;
      }

      const isEmpty = folders.length === 0 && events.length === 0;

      this.setState(prevState => {
        const updatedOpenedFolders = new Set(prevState.openedFolders);
        // Get the parent path from the encoded path to generate the correct folder instance ID
        const decodedPath = decodeEntityPath(encodedPath);
        const pathSegments = decodedPath.split("/");
        const parentPath = pathSegments.slice(0, -1).join("/");
        const folderInstanceId = this.generateFolderInstanceId(
          folder,
          parentPath
        );
        updatedOpenedFolders.add(folderInstanceId);

        return {
          selectedFolderId: folder.id,
          selectedFolderData: {
            ...folder,
            folders,
            events
          },
          folderData: folder,
          selectedView: isEmpty ? "empty-folder" : "folder",
          selectedEvent: null,
          selectedAlbum: null,
          selectedAlbumPhotos: [],
          folderLoadingId: null,
          openedFolders: updatedOpenedFolders,
          loading: false,
          subFoldersCurrentPage: 1,
          subFoldersNextPage: foldersNextPage,
          nextPage: nextPage,
          eventCurrentPage: 1
        };
      });
    } catch (error) {
      console.error("Failed to load folder data:", error);
      this.setState({ loading: false });
    }
  };

  handleBreadcrumbClick = async (
    entityId: number,
    entityType: EntityType,
    asType?: "folder" | "event"
  ) => {
    const url = new URL(window.location.href);
    const existingEncodedPath =
      this.state.encodedString || url.searchParams.get("p");

    let newEncodedPath: string | null = null;

    if (existingEncodedPath) {
      newEncodedPath = trimEncodedEntityPathTo(
        existingEncodedPath,
        entityId,
        entityType
      );
    }

    if (!newEncodedPath) {
      const prefix = typeMap[entityType];
      newEncodedPath = getEncodedEntityPath(`${prefix}:${entityId}`);
    }
    this.setEncodedString(newEncodedPath);

    url.searchParams.set("p", newEncodedPath);
    url.searchParams.delete("folderId");
    url.searchParams.delete("referenceId");
    url.searchParams.delete("eventId");
    url.searchParams.delete("albumId");

    window.history.pushState({}, "", url);
    this.setState({ loading: true });

    try {
      // ✅ Album
      if (entityType === "Album") {
        const albumRes = await fetch(
          `/api/v1/photo-manager/details?t=Album&id=${entityId}`
        );
        if (!albumRes.ok) throw new Error("Failed to fetch album");
        const albumData = await albumRes.json();
        const album = albumData.entities;

        const photos = await fetchAlbumPhotos(entityId, 1);

        this.setState({
          selectedAlbum: album,
          selectedAlbumPhotos: photos.entities,
          selectedView: "album",
          selectedEvent: null,
          selectedFolderId: null,
          selectedFolderData: null,
          loading: false,
          encodedString: newEncodedPath
        });
        return;
      }
      if (entityType === "LibraryFolder") {
        const [folderData, folderMeta] = await Promise.all([
          this.fetchFolderDetails(entityId),
          fetchFolderDetails(entityId)
        ]);
        const isEmpty =
          folderData.folders.length === 0 && folderData.events.length === 0;

        this.setState({
          selectedFolderId: entityId,
          selectedFolderData: {
            ...(folderMeta || {}),
            folders: folderData.folders,
            events: folderData.events
          },
          folderData: folderMeta,
          selectedView: isEmpty ? "empty-folder" : "folder",
          selectedEvent: null,
          selectedAlbum: null,
          selectedAlbumPhotos: [],
          loading: false,
          folderLoadingId: null,
          encodedString: newEncodedPath,
          subFoldersCurrentPage: 1,
          subFoldersNextPage: folderData.foldersNextPage,
          nextPage: folderData.meta.nextPage,
          eventCurrentPage: 1
        });
        return;
      }

      // ✅ Event or Event Shortcut (Gallery OR LibraryFolderReference coming from album path)
      if (entityType === "Gallery" || entityType === "LibraryFolderReference") {
        const isEvent = entityType === "Gallery" || asType === "event";
        const isFolder =
          entityType === "LibraryFolderReference" && asType === "folder";

        if (isEvent) {
          const event = await fetchEventBreadcrumbDetails(
            entityId,
            entityType === "LibraryFolderReference" ? entityId : null,
            newEncodedPath
          );

          fetchGalleryContent(
            entityId,
            entityType === "LibraryFolderReference" ? "referenceId" : undefined
          ).then(albums => {
            this.setState(prevState => ({
              albums: { ...prevState.albums, [event.id]: albums },
              selectedEvent: event,
              selectedAlbum: null,
              albumLoadingEventId: null,
              loading: false
            }));
          });

          return;
        }

        if (isFolder) {
          const [folderData, folderMeta] = await Promise.all([
            this.fetchFolderDetails(entityId, "LibraryFolderReference"),
            fetchFolderDetails(entityId, "LibraryFolderReference")
          ]);
          const isEmpty =
            folderData.folders.length === 0 && folderData.events.length === 0;

          this.setState({
            selectedFolderId: entityId,
            selectedFolderData: {
              ...(folderMeta || {}),
              folders: folderData.folders,
              events: folderData.events
            },
            folderData: folderMeta,
            selectedView: isEmpty ? "empty-folder" : "folder",
            selectedEvent: null,
            selectedAlbum: null,
            selectedAlbumPhotos: [],
            loading: false,
            folderLoadingId: null,
            encodedString: newEncodedPath,
            subFoldersCurrentPage: 1,
            subFoldersNextPage: folderData.foldersNextPage,
            nextPage: folderData.meta.nextPage,
            eventCurrentPage: 1
          });

          return;
        }
      }

      console.warn("Unknown entityType in breadcrumb click:", entityType);
      this.setState({ loading: false });
    } catch (error) {
      console.error("Error handling breadcrumb click:", error);
      this.setState({ loading: false });
    }
  };

  handleCreateEvent = () => {};

  isPendingURLResolution = (): boolean => {
    const url = new URL(window.location.href);
    const hasEventId = url.searchParams.has("eventId");
    const hasAlbumId = url.searchParams.has("albumId");
    const hasFolderId = url.searchParams.has("folderId");

    if (hasFolderId && !this.state.selectedFolderData) return true;

    if (hasEventId && !this.state.selectedEvent) return true;
    if (hasAlbumId && !this.state.selectedAlbum) return true;

    return false;
  };

  handleCreateFolder = (type: CreateFolderType) => {
    this.setState({ showCreateFolderModal: true });
    this.setCreateFolderType(type);
  };

  handleCloseFolderModal = () => {
    this.setState({
      showCreateFolderModal: false,
      isHeaderFolderCreation: false
    });
  };

  handleFolderCreateSuccess = () => {
    this.setState({
      showCreateFolderModal: false,
      isHeaderFolderCreation: false
    });
  };

  openCreateModal = () => this.setState(ModalState.showCreateFolderModal);

  handleEventCreateSuccess = () => {
    this.setState({ showCreateEventModal: false });
  };

  toggleHeaderCreateDropdown = () => {
    this.setState(prevState => ({
      showHeaderCreateDropdown: !prevState.showHeaderCreateDropdown
    }));
  };

  closeHeaderCreateDropdown = () => {
    this.setState(ModalState.hideHeaderDropdown);
  };

  handleHeaderGalleryClick = () => {
    this.closeHeaderCreateDropdown();
    if (!this.props.featureFlags.simpleEventCreationEnabled) {
      const params = new URLSearchParams();
      if (this.state.selectedFolderId) {
        params.append(
          "library_folder_id",
          this.state.selectedFolderId.toString()
        );
      }
      window.location.href = `/dashboard/events/new/our?${params}`;
    } else {
      this.setState({ isHeaderEventCreation: true });
      this.openCreateEventModal();
    }
  };

  handleHeaderFolderClick = () => {
    this.closeHeaderCreateDropdown();
    // Header create always creates folders at root level
    const folderType = "library-folder";

    this.openCreateModal();
    this.setCreateFolderType(folderType);
    this.setState({ isHeaderFolderCreation: true });
  };

  handleClickOutside = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    const headerIconContainer = target.closest(".ws-header-icon-container");

    if (!headerIconContainer && this.state.showHeaderCreateDropdown) {
      this.closeHeaderCreateDropdown();
    }
  };

  redirectToEventCreatePage = () => {
    const params = new URLSearchParams();
    if (this.state.selectedFolderId)
      params.append(
        "library_folder_id",
        this.state.selectedFolderId.toString()
      );
    window.location.href = `/dashboard/events/new/our?${params}`;
  };
  setFolderId = (id: number) => this.setState({ selectedFolderId: id });

  handleCreateEventSuccess = (newEvent: EventType, folderId: number | null) => {
    this.setState(
      prev => {
        let updatedRootFolders = [...prev.rootFolders];
        let updatedEventsList = [...prev.eventsList];
        //Add children and events within the folderdata type
        const insertIntoFolder = (
          folders: EnhancedFolder[]
        ): EnhancedFolder[] => {
          return folders.map(folder => {
            if (folder.id === folderId) {
              const updatedEvents = folder.events
                ? [...folder.events, newEvent]
                : [newEvent];
              return { ...folder, events: updatedEvents };
            }
            if (folder.children) {
              return {
                ...folder,
                children: insertIntoFolder(folder.children)
              };
            }
            return folder;
          });
        };

        if (folderId) {
          updatedRootFolders = insertIntoFolder(prev.rootFolders);

          if (prev.selectedFolderId === folderId && prev.selectedFolderData) {
            return {
              rootFolders: updatedRootFolders,
              selectedFolderData: {
                ...prev.selectedFolderData,
                events: [...(prev.selectedFolderData.events || []), newEvent]
              },
              selectedEvent: newEvent,
              selectedAlbum: null,
              showCreateEventModal: false,
              isHeaderEventCreation: false
            };
          }

          return {
            rootFolders: updatedRootFolders,
            selectedEvent: newEvent,
            selectedAlbum: null,
            showCreateEventModal: false,
            isHeaderEventCreation: false
          };
        } else {
          updatedEventsList = [newEvent, ...prev.eventsList];
          const updatedOpenedEvents = new Set(prev.openedEvents);
          updatedOpenedEvents.add(newEvent.id);

          return {
            eventsList: updatedEventsList,
            eventsView: updatedEventsList,
            openedEvents: updatedOpenedEvents,
            albums: { ...prev.albums, [newEvent.id]: [] },
            selectedEvent: newEvent,
            selectedAlbum: null,
            showCreateEventModal: false,
            isHeaderEventCreation: false
          };
        }
      },
      () => {
        const url = new URL(window.location.href);

        if (folderId) {
          url.searchParams.delete("folderId");
        }

        window.history.pushState({}, "", url);
        window.dispatchEvent(new PopStateEvent("popstate"));
      }
    );
  };

  addNewFolderToTree = (newFolder: EnhancedFolder) => {
    const { parentFolderId, id } = newFolder;

    if (parentFolderId === null) {
      this.reloadFolderData("root", id, null);
    } else {
      this.reloadFolderData("nested", id, parentFolderId);
    }
  };

  reloadEventData = async (
    type: "root" | "nested" = "root",
    parentFolderId: number | null = null,
    entityType?: string
  ) => {
    try {
      if (type === "root") {
        await fetchEventList(
          1,
          (val: EventType[], nextPage: number | null) => {
            this.setState({
              eventsList: [...val],
              eventsView: [...val],
              nextPage: nextPage,
              eventListNextPage: nextPage
            });
          },
          this.state.selectedEventFilter
        );
      } else if (type === "nested" && parentFolderId !== null) {
        await Promise.all([
          // Reload folder events
          fetchFolderEvents(parentFolderId, 1, entityType).then(events => {
            // Update the folder's events in the tree
            const updatedTree = this.updateFolderInTree(
              this.state.rootFolders,
              parentFolderId,
              { events }
            );

            this.setState(prev => {
              const isViewingThisFolder =
                prev.selectedFolderId === parentFolderId;

              return {
                rootFolders: updatedTree,
                ...(isViewingThisFolder && {
                  selectedFolderData: {
                    ...prev.selectedFolderData,
                    events: events
                  }
                })
              };
            });
          })
        ]);
      }
    } catch (error) {
      console.error("Error reloading event data:", error);
    }
  };

  reloadFolderData = async (
    type: "root" | "nested",
    loadingId: number,
    parentFolderId: number | null
  ) => {
    this.setState({ folderLoadingId: loadingId });

    try {
      if (type === "root") {
        const foldersResponse = await fetchFoldersList(1);
        const rootFolders = foldersResponse.entities;

        return new Promise<void>(resolve => {
          this.setState(
            prev => {
              const isViewingRoot = prev.selectedFolderId === null;

              return {
                rootFolders,
                rootFoldersCurrentPage: foldersResponse.meta.page || 1,
                rootFoldersNextPage: foldersResponse.meta.nextPage || null,
                ...(isViewingRoot && {
                  selectedFolderData: {
                    ...prev.selectedFolderData,
                    folders: rootFolders
                  }
                }),
                folderLoadingId: null
              };
            },
            () => resolve()
          );
        });
      } else if (type === "nested" && typeof parentFolderId === "number") {
        const [foldersResponse, subEvents] = await Promise.all([
          fetchSubFolders(parentFolderId, 1),
          fetchFolderEvents(parentFolderId)
        ]);

        const subFolders = foldersResponse.entities;

        const updatedTree = this.updateFolderInTree(
          this.state.rootFolders,
          parentFolderId,
          {
            children: subFolders,
            events: subEvents
          }
        );

        return new Promise<void>(resolve => {
          this.setState(
            prev => {
              const isViewingThisFolder =
                prev.selectedFolderId === parentFolderId;

              return {
                rootFolders: updatedTree,
                ...(isViewingThisFolder && {
                  selectedFolderData: {
                    ...prev.selectedFolderData,
                    folders: subFolders,
                    events: subEvents
                  },
                  subFoldersCurrentPage: foldersResponse.meta.page || 1,
                  subFoldersNextPage: foldersResponse.meta.nextPage || null
                }),
                folderLoadingId: null
              };
            },
            () => resolve()
          );
        });
      }
    } catch (error) {
      return new Promise<void>(resolve => {
        this.setState({ folderLoadingId: null }, () => resolve());
      });
    }
  };

  refreshFolderTree = async () => {
    try {
      const foldersResponse = await fetchFoldersList(1);
      this.setState({
        rootFolders: foldersResponse.entities,
        rootFoldersCurrentPage: foldersResponse.meta.page || 1,
        rootFoldersNextPage: foldersResponse.meta.nextPage || null
      });
    } catch (error) {
      console.error("Error refreshing folder tree:", error);
    }
  };

  refreshEntireSideBar = async () => {
    try {
      const [_, foldersResponse] = await Promise.all([
        this.fetchEventListFunction(this.state.eventCurrentPage),
        fetchFoldersList(1)
      ]);

      this.setState({
        rootFolders: foldersResponse.entities,
        rootFoldersCurrentPage: foldersResponse.meta.page || 1,
        rootFoldersNextPage: foldersResponse.meta.nextPage || null
      });
    } catch (error) {
      console.error("Error refreshing entire sidebar:", error);
    }
  };

  onReNameClicked = async (folder: Folder | BasicFolderData, name: string) => {
    await updateFolder(folder.id, name, folder.parentFolderId);
    this.setState({ showRenameModal: false });
    await this.reloadFolderData("root", folder.id, null);

    if (folder.parentFolderId) {
      await this.reloadFolderData("nested", folder.id, folder.parentFolderId);
    }
  };

  onDeleteFolder = async (folder: Folder | BasicFolderData) => {
    try {
      const deleteResult = await deleteFolder(folder.id);

      if (!deleteResult) {
        return;
      }

      // Refetch entire sidebar tree to remove the folder and all its shortcuts
      await this.refreshFolderTree();
    } catch (error) {
      console.error("Error in onDeleteFolder:", error);
    }
  };

  setNavigatingAfterDeletion = (flag: boolean) => {
    this.setState({
      isNavigatingAfterDeletion: flag,
      // Clear openedFolders to reset expansion state and let fresh data determine what should be expanded
      openedFolders: flag ? new Set<string>() : this.state.openedFolders
    });
  };

  // Event action handlers
  setShowRenameEventModal = (event: EventType | null) => {
    this.setState({
      showRenameEventModal: !!event,
      selectedEventForAction: event
    });
  };

  setShowDeleteEventModal = (event: EventType | null) => {
    this.setState({
      showDeleteEventModal: !!event,
      selectedEventForAction: event
    });
  };

  onRenameEvent = async (event: EventType, newName: string) => {
    try {
      const updatedEvent = await updateEventAPI(event.id, { name: newName });

      // Update the event in the state
      this.setState(prevState => {
        const updatedEventsList = prevState.eventsList.map(e =>
          e.id === event.id ? { ...e, name: newName } : e
        );
        const updatedEventsView = prevState.eventsView.map(e =>
          e.id === event.id ? { ...e, name: newName } : e
        );

        return {
          eventsList: updatedEventsList,
          eventsView: updatedEventsView,
          selectedEvent:
            prevState.selectedEvent?.id === event.id
              ? { ...prevState.selectedEvent, name: newName }
              : prevState.selectedEvent
        };
      });

      // Update folder data if event is in current folder
      if (this.state.selectedFolderData?.events) {
        this.setState(prevState => ({
          selectedFolderData: {
            ...prevState.selectedFolderData!,
            events: prevState.selectedFolderData!.events.map(e =>
              e.id === event.id ? { ...e, name: newName } : e
            )
          }
        }));
      }

      const updatedTree = this.updateEventInTree(
        this.state.rootFolders,
        event.id,
        newName
      );
      this.setState({ rootFolders: updatedTree });

      this.setState({
        showRenameEventModal: false,
        selectedEventForAction: null
      });

      toastr.success("Event renamed successfully");
    } catch (error) {
      console.error("Error renaming event:", error);
      throw error;
    }
  };

  onDeleteEvent = async (event: EventType) => {
    try {
      await deleteEventAPI(event.id);

      // Check if we need to navigate away before doing anything else
      const shouldNavigateAway = this.state.selectedEvent?.id === event.id;

      // Remove the event from the state
      this.setState(prevState => {
        const updatedEventsList = prevState.eventsList.filter(
          e => e.id !== event.id
        );
        const updatedEventsView = prevState.eventsView.filter(
          e => e.id !== event.id
        );

        // Clear selected event if it's the one being deleted
        const selectedEvent =
          prevState.selectedEvent?.id === event.id
            ? null
            : prevState.selectedEvent;

        return {
          eventsList: updatedEventsList,
          eventsView: updatedEventsView,
          folderData: null,
          selectedEvent,
          selectedAlbum: selectedEvent ? prevState.selectedAlbum : null,
          selectedAlbumPhotos: selectedEvent
            ? prevState.selectedAlbumPhotos
            : []
        };
      });

      // Update folder data if event is in current folder
      if (this.state.selectedFolderData?.events) {
        this.setState(prevState => ({
          selectedFolderData: {
            ...prevState.selectedFolderData!,
            events: prevState.selectedFolderData!.events.filter(
              e => e.id !== event.id
            )
          }
        }));
      }

      // Refetch sidebar tree to remove the event from the tree
      await this.refreshFolderTree();

      // Refetch the current page data based on URL (unless we're navigating away)
      if (!shouldNavigateAway) {
        try {
          await this.handleURLChange();
        } catch (error) {
          console.error("Error refreshing page data:", error);
        }
      }

      // Close modal after all operations are complete
      this.setState({
        showDeleteEventModal: false,
        selectedEventForAction: null
      });

      toastr.success("Event deleted successfully");

      // Navigate back to parent folder if we deleted the currently selected event
      if (shouldNavigateAway) {
        const url = new URL(window.location.href);
        const encodedPath = url.searchParams.get("p");

        if (encodedPath) {
          // Decode the path to work with segments
          const decoded = decodeEntityPath(encodedPath);
          if (decoded) {
            const pathParts = decoded.split("/");

            // Remove the last segment (the deleted event like g:341)
            pathParts.pop();

            if (pathParts.length > 0) {
              // Re-encode the path without the deleted event
              const newEncodedPath = getEncodedEntityPath(pathParts.join("/"));
              url.searchParams.set("p", newEncodedPath);
            } else {
              // If no parent folder, go to root
              url.searchParams.delete("p");
            }
          } else {
            url.searchParams.delete("p");
          }
        } else {
          url.searchParams.delete("p");
        }

        window.history.pushState({}, "", url.toString());
        this.handleURLChange();
      }
    } catch (error) {
      console.error("Error deleting event:", error);
      toastr.error("Failed to delete event");
      // Close modal even on error
      this.setState({
        showDeleteEventModal: false,
        selectedEventForAction: null
      });
    }
  };

  addShortcutToTree = (shortcutData: {
    id: number;
    referenceId: number;
    name: string;
    type: "folder" | "event";
    targetParentFolderId: number | null;
    sourceEntityId: number;
    sourceEntityType: "LibraryFolder" | "Event";
  }) => {
    const { targetParentFolderId, id, type } = shortcutData;

    if (targetParentFolderId === null) {
      if (type === "folder") {
        this.reloadFolderData("root", id, null);
      } else {
        this.reloadEventData("root");
      }
      return;
    }

    this.reloadFolderData("nested", id, targetParentFolderId);
  };

  onShortcutDelete: (shortCut: ShortCutType) => void = async (
    shortCut: ShortCutType
  ) => {
    // Refetch entire sidebar tree to remove the shortcut from all locations
    await this.refreshFolderTree();
    if (this.state.selectedFolderId === shortCut.id) {
      this.setState(prev => ({
        selectedFolderData: {
          ...prev.selectedFolderData,
          folders: [],
          events: []
        },
        selectedView: "empty-folder"
      }));
    }
  };

  onMovingSuccess = ({
    shouldReloadTreeView,
    src,
    destination
  }: {
    shouldReloadTreeView?: boolean;
    src?: any;
    destination?: any;
  }) => {
    const folder = this.state.sourceEntityToMove;
    if (folder) {
      // Redirect to parent folder after moving
      if (folder.parentFolderId) {
        this.handleBreadcrumbClick(folder.parentFolderId, "LibraryFolder");
      }

      // Update sidebar - always reload source folder data (where folder was moved from)
      if (folder.parentFolderId) {
        this.reloadFolderData("nested", folder.id, folder.parentFolderId);
      } else {
        // For root-level folders
        this.reloadFolderData("root", folder.id, null);
      }

      // Update destination folder in sidebar (conditionally if expanded)
      if (destination?.entityId) {
        // Generate folder instance ID for root level (empty parent path)
        const destinationFolderInstance = `f:${destination.entityId}`;
        if (this.isFolderInstanceExpanded(destinationFolderInstance)) {
          // Reload the destination folder's children to show the moved folder
          this.reloadFolderData(
            "nested",
            destination.entityId,
            destination.entityId
          );
        }
      } else if (destination?.entityId === null) {
        // Moving to root - reload root folders
        this.reloadFolderData("root", 0, null);
      }

      if (shouldReloadTreeView) {
        this.reloadFolderData("root", folder.id, null);
      }
    }
  };

  areAnyFiltersActive = () => {
    // Check if any permission filter is active (not null)
    const hasActivePermissionFilter = this.state.selectedPermissionFilters.some(
      (filter: PermissionFilterType) => filter.value !== null
    );

    // Check if redaction filter is active (not null)
    const hasActiveRedactionFilter = this.state.showRedactedPhotos !== null;

    return hasActivePermissionFilter || hasActiveRedactionFilter;
  };

  render() {
    const {
      selectedEvent,
      albums,
      eventsList,
      eventsView,
      openedEvents,
      selectedAlbumPhotos,
      selectedAlbum,
      loading,
      isMobile,
      eventCurrentPage,
      photoCurrentPage,
      nextPhotoPage,
      photosCount,
      selectedFolderData,
      eventListCurrentPage,
      eventListNextPage,
      albumLoadingEventId,
      photosLoading,
      markUploadPopupId,
      eventsLoading,
      activeShareModalEventId,
      selectedEventFilter,
      noFilteredData,
      showRedactedPhotos,
      selectedView,
      sourceEntityToMove
    } = this.state;

    const selectedEventFromEventList = eventsList.find(
      event => event.id === this.state.showNewAlbumModal
    )!;

    return (
      <PhotoManagerContext.Provider
        value={{
          ...this.state,
          updateEventList: this.updateEventList,
          optimisticUpdateEventName: this.optimisticUpdateEventName,
          optimisticUpdateFolderName: this.optimisticUpdateFolderName,
          updatePrivacy: this.updatePrivacy,
          schoolUser: this.props.schoolUser,
          publicSharingDisabled: this.props.publicSharingDisabled,
          eventPasswordsDisabled: this.props.eventPasswordsDisabled,
          groupPhotosEnabled: this.props.featureFlags.groupPhotosEnabled,
          currentUserId: this.props.currentUserId,
          navigateToRoot: this.navigateToRoot,
          showActionTooltip: this.showActionTooltip,
          onCreateAlbumSuccess: this.onCreateAlbumSuccess,
          onDeleteSuccess: this.onDeleteSuccess,
          photosCount: this.state.photosCount,
          updateAlbumsList: this.updateAlbumsList,
          onEditSuccessUpdateAlbum: this.onEditSuccessUpdateAlbum,
          applyEventsFilter: this.applyEventsFilter,
          selectedEventFilter: selectedEventFilter,
          clearFilter: this.clearFilter,
          noFilteredData: this.state.noFilteredData,
          isFilterEventsLoading: this.state.isFilterEventsLoading,
          setEventsLoading: this.setEventsLoading,
          refreshAlbumDetails: this.refreshAlbumDetails,
          onAlbumDeleteSuccess: this.onAlbumDeleteSuccess,
          redactionCheckEnabled: this.props.redactionCheckEnabled,
          photoPermissionAttributes: this.props.photoPermissionAttributes,
          hasRedactedParticipants: this.props.hasRedactedParticipants,
          handlePermissionChange: this.handlePermissionChange,
          handleRedactionChange: this.handleRedactionChange,
          isFilterSelected: this.isFilterSelected,
          showRedactedPhotos: showRedactedPhotos,
          resetPhotoFilters: this.resetPhotoFilters,
          setShowPhotoFilter: this.setShowPhotoFilter,
          areAnyFiltersActive: this.areAnyFiltersActive,
          handleEventClick: this.handleEventClick,
          setSelectedView: this.setSelectedView,
          setFolderData: this.setFolderData,
          folderData: this.state.folderData,
          openCreateModal: this.openCreateModal,
          setCreateFolderType: this.setCreateFolderType,
          redirectToEventCreatePage: this.redirectToEventCreatePage,
          openedFolders: this.state.openedFolders,
          openedEventInstances: this.state.openedEventInstances,
          handleFolderCollapse: this.handleFolderCollapse,
          handleEventCollapse: this.handleEventCollapse,
          generateEventInstanceId: this.generateEventInstanceId,
          isEventInstanceExpanded: this.isEventInstanceExpanded,
          isFolderInstanceExpanded: this.isFolderInstanceExpanded,
          isExpandedFolder: (folderId: number) =>
            this.isFolderInstanceExpanded(`f:${folderId}`),
          setFolderId: this.setFolderId,
          addNewFolderToTree: this.addNewFolderToTree,
          setSelectedFolderActions: this.setSelectedFolderActions,
          setShowRenameModal: this.setShowRenameModal,
          closeRenameModal: this.closeRenameModal,
          setShowDeleteModal: this.setShowDeleteModal,
          closeDeleteModal: this.closeDeleteModal,
          reloadFolderData: this.reloadFolderData,
          reloadEventData: this.reloadEventData,
          refreshFolderTree: this.refreshFolderTree,
          refreshEntireSideBar: this.refreshEntireSideBar,
          handleFolderClick: this.handleFolderClick,
          invitedEventsMode: this.props.invitedEventsMode,
          organizationName: this.props.organizationName,
          canCreateRootContent: this.props.canCreateRootContent,
          openCreateEventModal: this.openCreateEventModal,
          isFilterApplied: this.isFilterApplied,
          showEventsFilterPanel: this.showEventsFilterPanel,
          closeFilterEventsPanel: this.closeFilterEventsPanel,
          toggleFolderFeatureModal: this.toggleFolderFeatureModal,
          toggleDeleteShortcutModal: this.toggleDeleteShortcutModal,
          setShowMovePopup: this.setShowMovePopup,
          closeMovePopup: this.closeMovePopup,
          setSourceEntityTypeToMove: this.setSourceEntityTypeToMove,
          setEncodedString: this.setEncodedString,
          libraryRootFolders: this.state.rootFolders,
          handleBreadcrumbClick: this.handleBreadcrumbClick,
          albumLoadingEventId: albumLoadingEventId,
          handleURLChange: this.handleURLChange,
          handleSidebarResize: this.handleSidebarResize,
          setDeletedViewState: this.setDeletedViewState,
          removeFolderFromEncodedPath: this.removeFolderFromEncodedPath,
          onDeleteFolder: this.onDeleteFolder,
          setNavigatingAfterDeletion: this.setNavigatingAfterDeletion,
          setShowRenameEventModal: this.setShowRenameEventModal,
          setShowDeleteEventModal: this.setShowDeleteEventModal,
          onRenameEvent: this.onRenameEvent,
          onDeleteEvent: this.onDeleteEvent,
          setRootEventsView: this.setRootEventsView,
          simpleEventCreationEnabled:
            this.props.featureFlags.simpleEventCreationEnabled,
          showDoNotPhotographInUploader:
            this.props.featureFlags.showDoNotPhotographInUploader,
          // Modal control methods
          setActiveShareModalEventId: this.setActiveShareModalEventId,
          setMarkUploadPopupId: this.setMarkUploadCompletePopup,
          setPrivacyPopupId: this.setPrivacyPopupId,
          setShowNewAlbumModal: this.setShowNewAlbumModal,
          setShowCreateFolderModal: this.setShowCreateFolderModal,
          setShowCreateEventModal: this.setShowCreateEventModal,
          setShowFolderFeatureModal: this.setShowFolderFeatureModal,
          setShowDeleteShortcutModal: this.setShowDeleteShortcutModal,
          toggleManagePermissionsModal: this.toggleManagePermissionsModal,
          loadMoreRootFolders: this.loadMoreRootFolders,
          loadMoreSubFolders: this.loadMoreSubFolders
        }}
      >
        <div className="geo-manager-body">
          {loading || this.isPendingURLResolution() ? (
            <div className="gss-loader">
              <img src={gssNewLoader} />
            </div>
          ) : this.noFolderOrEventsAvailable() ? (
            <NoEvents />
          ) : (
            <div className="geo-manager-sub-body">
              <PhotoManagerSidebar
                handleFolderClickInSidebar={this.handleFolderClickInSidebar}
                handleEventClickInSidebar={this.handleEventClickInSidebar}
                handleAlbumClick={this.handleAlbumClick}
                jumpToContentView={this.jumpToContentView}
                getFolderPath={this.getFolderPath}
                handlePageChange={this.handlePageChange}
                loadMore={this.loadMore}
                toggleHeaderCreateDropdown={this.toggleHeaderCreateDropdown}
                handleHeaderGalleryClick={this.handleHeaderGalleryClick}
                handleHeaderFolderClick={this.handleHeaderFolderClick}
              />
              <div
                onClick={() => {
                  if (this.state.showPhotosFilter)
                    this.setState({ showPhotosFilter: false });
                }}
                className="geo-manager-content"
                id="content-view"
              >
                <RenderContentArea
                  {...this.state}
                  handleFolderClick={this.handleFolderClick}
                  handleCreateFolder={this.handleCreateFolder}
                  handleEventClick={this.handleEventClick}
                  handlePageChange={this.handlePageChange}
                  navigateToRoot={this.navigateToRoot}
                  navigateToAlbum={this.navigateToAlbum}
                  fetchAlbumPhotosFunction={this.fetchAlbumPhotosFunction}
                  onDeleteSuccess={this.onDeleteSuccess}
                  showActionTooltip={this.showActionTooltip}
                  togglePhotoSelection={this.togglePhotoSelection}
                  clearSelection={this.clearSelection}
                  onCreateAlbumSuccess={this.onCreateAlbumSuccess}
                  updateAlbumsList={this.updateAlbumsList}
                  onEditSuccessUpdateAlbum={this.onEditSuccessUpdateAlbum}
                  setActiveShareModalEventId={this.setActiveShareModalEventId}
                  setPrivacyPopupId={this.setPrivacyPopupId}
                  setMarkUploadCompletePopup={this.setMarkUploadCompletePopup}
                  isPendingURLResolution={this.isPendingURLResolution}
                  handleAlbumClick={this.handleAlbumClick}
                  setShowNewAlbumModal={(id: number) =>
                    this.setState({ showNewAlbumModal: id })
                  }
                  openCreateEventModal={this.openCreateEventModal}
                  libraryRootFolders={this.state.rootFolders}
                />
              </div>
            </div>
          )}

          <PhotoManagerModals
            findEventById={this.findEventById}
            selectedEventFromEventList={selectedEventFromEventList}
            handleCreateEventSuccess={this.handleCreateEventSuccess}
            handleCloseFolderModal={this.handleCloseFolderModal}
            handleCloseEventModal={this.handleCloseEventModal}
            onReNameClicked={this.onReNameClicked}
            onDeleteFolder={this.onDeleteFolder}
            addShortcutToTree={this.addShortcutToTree}
            onShortcutDelete={this.onShortcutDelete}
            onMovingSuccess={this.onMovingSuccess}
            onRenameEvent={this.onRenameEvent}
            onDeleteEvent={this.onDeleteEvent}
            onCloseFolderFeatureModal={this.onCloseFolderFeatureModal}
            onCloseDeleteShortcutModal={this.onCloseDeleteShortcutModal}
          />
        </div>
      </PhotoManagerContext.Provider>
    );
  }
}

export default PhotoManager;
